export const getPopupContainer = (triggerNode: HTMLElement) => {
  const cardParent = getPopupCard(triggerNode);
  const slotNode = cardParent?.querySelector<HTMLElement>('.Card--addons');
  if (slotNode) {
    return slotNode;
  }
  return document.body;
};

export const getPopupCard = (triggerNode: HTMLElement) => {
  const cardParent = triggerNode.closest<HTMLElement>('.card');
  return cardParent;
};
